import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import styles from './NavRail.module.css';

const Icon = ({ d, size = 19 }) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth={1.6}
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
  >
    {(Array.isArray(d) ? d : [d]).map((p, i) => <path key={i} d={p} />)}
  </svg>
);

const NAV_ITEMS = [
  {
    label: 'Home',
    path: '/',
    icon: 'M22 12h-4l-3 9L9 3l-3 9H2',
    matchFn: (p) => p === '/',
  },
  {
    label: 'Releases',
    path: '/releases',
    icon: 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z',
    matchFn: (p) => p.startsWith('/release'),
  },
  {
    label: 'Branches',
    path: '/branches',
    icon: 'M6 3v12 M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M18 9a9 9 0 0 1-9 9',
    matchFn: (p) => p.startsWith('/branch'),
  },
];

export default function NavRail() {
  const location = useLocation();

  return (
    <nav className={styles.rail} aria-label="Main navigation">
      <div className={styles.logo} aria-label="Collate Releases" title="Collate Releases">
        C
      </div>

      <div className={styles.navItems}>
        {NAV_ITEMS.map((item) => {
          const active = item.matchFn(location.pathname);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`${styles.navItem} ${active ? styles.navItemActive : ''}`}
              aria-label={item.label}
              aria-current={active ? 'page' : undefined}
              title={item.label}
            >
              {active && <span className={styles.activeBar} />}
              <Icon d={item.icon} size={19} />
              <span className={styles.navLabel}>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
